import { makeStyles } from "@material-ui/core"

export const reservationButtonStyle = makeStyles((theme) => ({

}));